export default "__VITE_ASSET__SauDoow___"